export default "__VITE_ASSET__Bhfkz4rS__"